import applyDefaultThemeStyles from './applyDefaultThemeStyles'
import keepNewBlockStyles from './keepNewBlockStyles'
import { toggleEditableBlocks } from '../updateDynamicText/toggleEditableBlocks'

export const applyStylingToNonEditable = ({
  editor,
  selectedTheme,
  isVerse,
  plainTextMode,
}) => {
  if (plainTextMode) return
  const { lockNonEditableBlocks, unlockNonEditableBlocks } =
    toggleEditableBlocks(editor)

  const placeCursorOnFocusedTables = (e) => {
    const focusedElement = e.target.bodyElement
    if (!focusedElement) return

    const dataCaseDetailTableElement = focusedElement.querySelector(
      '[data-case-detail-table]',
    )
    if (!dataCaseDetailTableElement) return

    editor.selection.collapse(false)
  }

  // Trigger before any command that could mutate content
  editor.on('BeforeExecCommand', () => {
    unlockNonEditableBlocks()
  })

  editor.on('NewBlock', (e) => {
    try {
      keepNewBlockStyles({ editor, newBlockEvent: e })
    } catch (error) {
      console.error('Failed to apply formatting:', error)
    }
  })

  // Trigger after any command is finished
  editor.on('ExecCommand', () => {
    setTimeout(() => {
      lockNonEditableBlocks()
    }, 0) // Ensure it locks after the command is executed
  })

  // Also trigger when a node or selection is changed (e.g., font change)
  editor.on('NodeChange', () => {
    unlockNonEditableBlocks()
    setTimeout(() => {
      lockNonEditableBlocks()
    }, 0)
  })

  editor.on('focus', (e) => {
    if (isVerse)
      applyDefaultThemeStyles({
        editor,
        tinyMceEvent: e,
        selectedTheme,
        isVerse,
      })
    placeCursorOnFocusedTables(e)
  })

  // On initialization, lock the blocks initially and apply default theme styles on new text boxes
  editor.on('init', (e) => {
    applyDefaultThemeStyles({ editor, tinyMceEvent: e, selectedTheme })
    lockNonEditableBlocks()
  })
}

export default applyStylingToNonEditable
